module.exports = __webpack_public_path__ + "img/chevron--red.85954e68.svg";